import _ from 'underscore'
import ShowBalanceHistoryCellRenderer from './ShowBalanceHistoryCellRenderer'
import messageResource from '../../../../messageResource'

function ShowPtoHistoryCellRenderer() {
    this.constructor = ShowPtoHistoryCellRenderer;
}

ShowPtoHistoryCellRenderer.prototype = _.create(ShowBalanceHistoryCellRenderer.prototype, {
    getCellGeneralClassName: function() {
        return "showPtoHistoryCell";
    },

    getFlagValue: function(value) {
        return value.pto; //TODO(petrov): refactor this function
    },
    getCellTooltipText: function() {
        return messageResource.getMessage("common.pto_history.show_pto_history.tooltip.text");
    }
});

export default ShowPtoHistoryCellRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/ShowPtoHistoryCellRenderer.js